export const BLOCKED_FILE_EXTENSIONS = [
  'zip', 'rar', '7z', 'tar', 'gz', 'bz2', // Archives
  'exe', 'dll', 'so', 'app', 'dmg', 'pkg', 'deb', 'msi', 'bin', // Executables
  'iso', 'sys' // System files
];

export function isFileAllowed(file: File): boolean {
  const extParts = file.name.split('.');
  const fileExt = extParts.length > 1 ? extParts.pop()?.toLowerCase() || '' : '';
  
  if (BLOCKED_FILE_EXTENSIONS.includes(fileExt)) {
    return false;
  }
  
  if (file.type === 'application/zip' || file.type === 'application/x-zip-compressed') {
    return false;
  }
  
  return true;
}
